// extracted by mini-css-extract-plugin
module.exports = {"productDocs":"productDocs_productDocs__bAeew","rightWrp":"productDocs_rightWrp__184ob","download":"productDocs_download__3vId6"};